// extracted by mini-css-extract-plugin
export default {"records-grid":"ModuleRecordRelation_records-grid__B7WmY"};